<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.oss-vat-rate.dialog.title' | translate"
		id="oss-vat-rate-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="oss-vat-rate-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1 align--medium-top">
						<ins-checkbox
							id="oss-vat-rate-dialog-active"
							[(ngModel)]="viewModel.bo.model.active"
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.active.label' | translate"
							[sklValidate]="getValidationKey('active')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.name.label' | translate">
							<ins-input
								[skl-focus-by]
								id="oss-vat-rate-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.oss-vat-rate.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.symbol.label' | translate">
							<ins-input
								id="oss-vat-rate-dialog-symbol"
								[(ngModel)]="viewModel.bo.model.symbol"
								[placeholder]="'scenes.configuration.shared.oss-vat-rate.dialog.form.symbol.placeholder' | translate"
								[sklValidate]="getValidationKey('symbol')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.country.label' | translate">
							<ins-select
								id="oss-vat-rate-dialog-countryId"
								display-text="name"
								[placeholder]="'ui.placeholders.empty' | translate"
								[converter]="viewModel.countryValueConverter"
								[(ngModel)]="viewModel.bo.model.countryId"
								[sklValidate]="getValidationKey('countryId')">
								@for (item of viewModel.countries; track item) {
									<ins-option
										[value]="item">
										{{item.name}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.oss-vat-rate.dialog.form.rate.label' | translate">
							<ins-input
								rtl="false"
								inputmode="decimal"
								id="oss-vat-rate-dialog-rate"
								[nullable]="true"
								[placeholder]="'scenes.configuration.shared.oss-vat-rate.dialog.form.rate.placeholder' | translate"
								[converter]="viewModel.rateConverter"
								[(ngModel)]="viewModel.rate.value"
								[sklValidate]="[getValidationKey('rate'), getValidationKey('rate', customValidationSun)]">
							</ins-input>
							<div slot="end">%</div>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="oss-vat-rate-dialog-button-cancel"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="oss-vat-rate-dialog-button-save"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>